// Uclean-Admin-Dashboard/src/mocks/promo/discountRules/store.js
// Mutable in-memory store so create/update "stick" within a session.

import fixtures from './fixtures.json';

export let rulesStore = [...fixtures];

export const _resetRulesStore = () => {
  rulesStore = [...fixtures];
};
